import { Box, Card, Grid } from '@mui/material/';
import { Button } from 'primereact/button';
import { Editor } from "primereact/editor";
import { Image } from 'primereact/image';
import React, { useState } from 'react';
import PriorityHighIcon from '../../../assets/images/icons/priority-high.svg';


// import { DataTable } from 'primereact/datatable';
// import { Column } from 'primereact/column';

// function CustomTabPanel(props) {
//     const { children, value, index, ...other } = props;

//     return (
//         <div
//             role="tabpanel"
//             hidden={value !== index}
//             id={`simple-tabpanel-${index}`}
//             aria-labelledby={`simple-tab-${index}`}
//             {...other}
//         >
//             {value === index && (
//                 <Box sx={{ p: 3 }}>
//                     <Typography>{children}</Typography>
//                 </Box>
//             )}
//         </div>
//     );
// }

// CustomTabPanel.propTypes = {
//     children: PropTypes.node,
//     index: PropTypes.number.isRequired,
//     value: PropTypes.number.isRequired,
// };

// function a11yProps(index) {
//     return {
//         id: `simple-tab-${index}`,
//         'aria-controls': `simple-tabpanel-${index}`,
//     };
// }

// const marks = [
//     {
//         value: 0,
//         label: '$1.234',
//     },
//     {
//         value: 50,
//         label: '$1.863',
//     },
//     {
//         value: 100,
//         label: '$2.863',
//     },
// ];

// const schain = [
//     {
//         node: 1,
//         domain: 'example.com'
//     },
//     {
//         node: 2,
//         domain: 'unruly.com'
//     }
// ]
export default function TicketDetails() {
    const [value, setValue] = useState('');
    const [text, setText] = useState('');
    // const [value, setValue] = React.useState(0);
    // const [progress, setProgress] = React.useState(0);

    // const handleChange = (event, newValue) => {
    //     setValue(newValue);
    // };

    // const [demandAlignment, setDemandAlignment] = useState([]);

    // const paginatorLeft = <Button type="button" icon="pi pi-refresh" text />;
    // const paginatorRight = <Button type="button" icon="pi pi-download" text />;

    // useEffect(() => {
    //     ApiData.getSupply().then(data => setDemandAlignment(data));
    // }, []);

    // const demandName = () => {
    //     return (
    //         <div>
    //             <div className="supplyPartner flex justify-content-center">{demandAlignment[0].demandName}</div>
    //         </div>
    //     )
    // }

    // const supplyName = () => {
    //     return (
    //         <div>
    //             <div className="supplyPartner flex justify-content-center">{demandAlignment[0].supplyName}</div>
    //         </div>
    //     )
    // } 

    const renderHeader = () => {
        return (
            <span className="ql-formats">
                <button className="ql-bold" aria-label="Bold"></button>
                <button className="ql-italic" aria-label="Italic"></button>
                <button className="ql-underline" aria-label="Underline"></button>
                <button className="ql-strike" aria-label="Strike"></button>
                <button className="ql-list" value="ordered" aria-pressed="true"></button>
                <button className="ql-list" value="bullet" aria-pressed="true"></button>
                <button className="ql-link" aria-label="Link"></button>
                <button className="ql-image" aria-label="Image"></button>

            </span>
        );
    };

    const header = renderHeader();

    return (
        <Box sx={{ width: '100%', padding: '1rem' }} className="ticket-deatils">
            <Grid container spacing={2} className='ticket-deatils-wrapper'>
                <Grid item xs={12} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} className='ticket-deatils-header' >
                    <Grid item xs={6} sm={6} md={2} lg={2} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} className='fs-2' >
                        ID: 102
                    </Grid>
                    <Grid item xs={6} sm={6} md={4} lg={4} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} className='fs-2' >
                        Date created: 15 Dec 2023
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} className='fs-2' >
                        Priority: <Image src={PriorityHighIcon} alt="Image" width="24"></Image>
                    </Grid>
                    <Grid item xs={6} sm={6} md={3} lg={3} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} className='fs-2' >
                        Status: <span class="status status-open p-tag p-component p-tag-warning" data-pc-name="tag" data-pc-section="root"><span class="p-tag-value" data-pc-section="value">Open</span><span></span></span>
                    </Grid>
                </Grid> 
                <Grid item xs={12} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} className='ticket-deatils-body' >
                    <Card>
                        <div className='card-body'>is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</div>
                        <div className='card-footer'>15 Dec 2023, 06:00 pm  •  John Doe   </div>
                    </Card>
                    <Card>
                        <div className='card-body'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam</div>
                        <div className='card-footer'>15 Dec 2023, 07:30 pm  •  Brad Damon</div>
                    </Card>
                </Grid>
            </Grid>
            {/* <Grid container spacing={2} className='ticket-deatils-body'>
                    <Grid item xs={12} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} className='fs-2' >
                        <Card>
                            <div className='card-body'>is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</div>
                            <div className='card-footer'>15 Dec 2023, 06:00 pm  •  John Doe   </div>
                        </Card>
                        <Card>
                            <div className='card-body'>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam</div>
                            <div className='card-footer'>15 Dec 2023, 07:30 pm  •  Brad Damon</div>
                        </Card>
                    </Grid>
                </Grid> */}
            <Grid container spacing={2} className='ticket-deatils-footer'>
                <Grid item xs={12} sx={{ gap: 1, flexGrow: 1, overflow: 'hidden auto' }} className='fs-2' >
                    <Box className='ticket-editor'>
                        <Editor value={text} onTextChange={(e) => setText(e.htmlValue)} headerTemplate={header} style={{ height: '65px' }} />
                        {/* <InputTextarea value={value} onChange={(e) => setValue(e.target.value)} rows={5} cols={30} /> */}
                        <Button label="Send" type="submit" icon="pi pi-send" />
                    </Box>
                </Grid>
            </Grid>
        </Box>
    );
}